(() => {
  if (window.mzProductPdpInitialized) return;
  window.mzProductPdpInitialized = true;

  const configuratorSelector = 'modal-dialog[data-mz-configurator-modal]';

  function findConfigurator(trigger) {
    const controls = trigger?.getAttribute('aria-controls');
    if (controls) {
      const controlled = document.getElementById(controls);
      if (controlled?.matches(configuratorSelector)) return controlled;
    }
    return document.querySelector(configuratorSelector);
  }

  function openConfigurator(trigger) {
    const modal = findConfigurator(trigger);
    if (!modal || typeof modal.show !== 'function') return false;

    modal.show(trigger);
    const configurator = modal.querySelector('mz-product-configurator');
    const stepKey = trigger.dataset.configStepKey || '';
    const optionLabel = trigger.dataset.configOptionLabel || '';
    window.requestAnimationFrame(() => configurator?.openAt?.({ stepKey, optionLabel }));
    return true;
  }

  function openFinancing(trigger) {
    const productInfo = trigger?.closest('product-info') || document.querySelector('product-info');
    const financing = productInfo?.querySelector('leasing-flow') || document.querySelector('leasing-flow');
    if (!financing || typeof financing.open !== 'function') return false;
    const configuratorId = productInfo?.querySelector('[data-mz-configurator-open][aria-controls]')?.getAttribute('aria-controls');
    const configurator = configuratorId ? document.getElementById(configuratorId)?.querySelector('mz-product-configurator') : null;
    if (configurator && typeof configurator.openFinancing === 'function') {
      configurator.openFinancing(trigger);
      return true;
    }
    const priceCents = Number(trigger.dataset.priceCents || 0);
    financing.open({ trigger, priceCents });
    return true;
  }

  document.addEventListener('click', (event) => {
    const configuratorTrigger = event.target.closest(
      '[data-mz-configurator-open], a[href="#mz-configurator"], a[href$="#mz-configurator"]'
    );
    if (configuratorTrigger) {
      event.preventDefault();
      openConfigurator(configuratorTrigger);
      return;
    }

    const financingTrigger = event.target.closest('[data-mz-financing-showcase-open]');
    if (financingTrigger) {
      event.preventDefault();
      openFinancing(financingTrigger);
    }
  });

})();
